<template>
  <v-card color="grey lighten-3" id="holdCard">
    <div id="pdf"></div>
    <v-card-title>
      <v-col cols="12" :md="4" :sm="12" class="">
        <h4 class="green--text">Politik<span class="pink--text">.sms</span></h4>
      </v-col>
      <v-spacer/>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
      />
      <v-spacer/>
      <v-btn icon @click="exportPDF">
        <v-icon class="red--text">mdi-file</v-icon>
      </v-btn>
      <export-excel
          class="btn btn-default"
          :data="tableRowData"
          :fields="excelHeaders"
          type="csv"
          :name="title +'.xls'">
        <v-btn icon>
          <v-icon class="green--text">mdi-file-excel</v-icon>
        </v-btn>
      </export-excel>

    </v-card-title>
    <div id="printSection" ref="content">
      <v-data-table
          class="mytable"
          style="font-size: 8px"
          :group-by="groupBy"
          :headers="headers"
          :items="tableRowData"
          :search="search"
          :key="tableKey"
          :dense="dense"
          @click:row="rowClicked">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer/>
            <v-toolbar-title>
              <h5 class="green--text">{{ split2(title, ' ')[0] }}<span class="pink--text ml-2 ">{{
                  split2(title, ' ')[1]
                }}</span></h5>
            </v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
        </template>
        <template v-slot:footer>
          <v-divider/>
          <div class="text-justify caption pa-1" style="font-size: 8px">
            Disclaimer: This is a system generated report for personal use and
            is not to be transferred. This is not a legal document, for a legal
            document contact us via support@politik.co.ke
          </div>
          <v-divider/>
          <div class="text-start caption pa-1">
            <span class="green--text">Politik<span class="pink--text">.sms</span></span> - www.politik.co.ke &nbsp;
          </div>
          <div class="caption pa-1">
            <span class="font-weight-bold">Built by Moffhub Solutions</span>
          </div>
        </template>
        <template v-slot:item.image="{ item }" class="noPrint">
          <v-avatar
              size="80px"
          >
            <img
                alt="Avatar"
                :src="item.image"
            >
          </v-avatar>
        </template>
        <template v-slot:item.action="{ item }" class="noPrint">
          <v-btn outlined x-small v-if="freezeItem"
                 class="ma-1"
                 @click="freezeUnfreezeItem(item)"
                 color="green">
            Send
          </v-btn>
          <v-icon v-if="revokeOrder && item.status ==='pending'"
                  small
                  class="ma-1"
                  @click="revokeOrderD(item)"
                  color="red">
            lock
          </v-icon>
          <v-btn v-if="viewItem"
                 small
                 class="ma-1"
                 @click="seeItem(item)"
                 color="green">
            Link
          </v-btn>
          <v-btn v-if="allowEdit"
                 icon
                 x-small
                 class="ma-1 white--text"
                 @click="editItem(item)"
                 color="blue">
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn x-small icon
                 v-if="allowEdit"
                 color="red"
                 class="ma-1"
                 @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-icon small
                  v-if="logOut"
                  color="blue"
                  @click="logoutAttendant(item)">
            Cancel
          </v-icon>
        </template>
        <template v-slot:no-data>
          <h6>No Data in Table</h6>
        </template>

      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import print from "print-js";

export default {
  props: {
    headers: {
      required: true,
      type: Array || Object
    },
    viewItem: {
      type: Boolean,
      default: false
    },
    revokeOrder: {
      type: Boolean,
      default: false
    },
    fontee: {
      default: 14
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
    groupBy: {
      default: null,
      required: false
    },
    logOut: {
      type: Boolean,
      default: false
    },
    freezeItem: {
      type: Boolean,
      default: false
    },
    tableRowData: {
      required: true,
      type: Array || Object
    },
    title: {
      type: String,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      search: '',
      tableKey: 0,
    }
  },
  computed: {
    excelHeaders() {
      let df = {};
      for (let i = 0; i < this.headers.length; i++) {
        // console.log(this.headers[i]);
        if (this.headers[i].value !== 'action') {
          if (this.headers[i].value === 'phone') {
            df[this.headers[i].text] = {
              field: this.headers[i].value,
              callback: (value) => {
                return value.toString()
              }
            }
          } else {
            df[this.headers[i].text] = this.headers[i].value;
          }
        }
      }
      return df;
    }
  },
  methods: {
    editItem(item) {
      this.$emit('editItem', {
        item
      })
    },
    split2(str, delim) {
      var parts = str.split(delim);
      return [parts[0], parts.splice(1, parts.length).join(delim)];
    },
    revokeOrderD(item) {
      this.$emit('revokeOrderD', {
        item
      })
    },
    seeItem(item) {
      this.$emit('viewItem', {
        item
      })
    },
    freezeUnfreezeItem(item) {
      this.$emit('freezeUnfreeze', {
        item
      })
    },
    // viewItem(item) {
    //     this.$emit('viewItem', {
    //         item
    //     })
    // },
    logoutAttendant(item) {
      this.$emit('logoutAttendant', {
        item
      })
    },
    testPrint() {

      var divToPrint = this.$refs.content
      let newWin = window.open("");
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();
      newWin.close();
    },
    printPDF: function () {
      const prtHtml = document.getElementById('printSection').innerHTML;

// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                          <head>
                            ${stylesHtml}
                          </head>
                          <body>
                            ${prtHtml}
                          </body>
                        </html>`);

      // WinPrint.document.close();
      // WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    exportPDF() {
      print({
        printable: this.tableRowData,
        header: this.title.toUpperCase(),
        headerStyle: "margin:0 auto; justify:center;text-align:center",
        properties: this.headers.map(item => {
          return {
            field: item.value ? item.value : '----',
            displayName: item.text ? item.text : '-----'
          }
        }),
        type: 'json',
        css: "css/print.css",
        gridStyle: 'border: 1px solid green; margin-bottom: -1px;',
        gridHeaderStyle: 'color: green;  border: 2px solid #3971A5;text-align:left;',
        documentTitle: this.title.toUpperCase() + ".pdf"
      })
      // var title ="test";
      // var divContents = $("#printSection").html();
      // var $cssLink = $('link');
      // var printWindow = window.open('', '', 'height=' + window.outerHeight * 0.6 + ', width=' + window.outerWidth  * 0.6);
      // printWindow.document.write('<html><head><h2><b><title>' + title + '</title></b></h2>');
      // for(var i = 0; i<$cssLink.length; i++) {
      //     printWindow.document.write($cssLink[i].outerHTML);
      // }
      // printWindow.document.write('</head><body >');
      // printWindow.document.write(divContents);
      // printWindow.document.write('</body></html>');
      // printWindow.document.close();
      // printWindow.onload = function () {
      //     printWindow.focus();
      //     setTimeout( function () {
      //         printWindow.print();
      //         printWindow.close();
      //     }, 100);
      // }
      // var divElements = document.getElementById("printSection").innerHTML;
      //
      // var oldPage = document.body.innerHTML;
      //
      // document.body.innerHTML =
      //
      //     "<html><head><title></title></head><body>" +
      //     divElements + "</body>";
      // window.print();
      // document.body.innerHTML = oldPage;
      // const element = document.getElementById('printSection');
      // const opt = {
      //     margin: 0.25,
      //     filename: this.title.toUpperCase() + '.pdf',
      //     image: {type: 'jpeg', quality: 0.98},
      //     html2canvas: {scale: 2},
      //     jsPDF: {unit: 'mm', format: 'a4', orientation: 'landscape'}
      // };
      // // html2pdf(element, opt);
      // html2pdf().set(opt).from(element).save();
    },
    exportCSV() {
    },
    deleteItem(item) {
      const index = this.tableRowData.indexOf(item);
      this.$emit('deleteItem', {
        item
      })
    },
    rowClicked(e) {
      this.$emit('rowClicked', {
        e
      })
    },
  },
  name: "TableWidget"
}
</script>

<style lang="css">
/*.mytable table tr:nth-of-type(odd) {*/
/*  background-color: #bcd3ef;*/
/*  border-bottom: none !important;*/
/*}*/
@media print {
  .noPrint {
    visibility: hidden;
  }
}
</style>
